export const getTransactionDisplay = (item, mode) => {
  if (mode === 'pending') {
    return {
      date: item.transaction_date,
      customer: `${item.customer?.firstName || ''} ${item.customer?.lastName || ''}`.trim(),
      customerId: item.customer?._id,
      supplier: item.supplier?.name,
      supplierId: item.supplier?._id,
      type: item.transaction_type,
      document: item.document,
      note: item.notes,
      amount: item.amount,
      attachments: item.attachments || [],
    };
  }

  if (mode === 'updateApproval' || item.approve_status === 3) {
    return {
      date: item.updated_transaction_date,
      customer: `${item.updated_customer?.firstName || ''} ${item.updated_customer?.lastName || ''}`.trim(),
      customerId: item.updated_customer?._id,
      supplier: item.updated_supplier?.name,
      supplierId: item.updated_supplier?._id,
      type: item.updated_transaction_type,
      document: item.updated_document,
      note: item.updated_notes,
      amount: item.updated_amount,
      attachments: item.updated_attachments || [],
    };
  }

  if (item.pending_transaction_id) {
    return {
      date: item.pending_transaction?.transaction_date,
      customer: `${item.pending_transaction_customer?.firstName || ''} ${item.pending_transaction_customer?.lastName || ''}`.trim(),
      customerId: item.pending_transaction_customer?._id,
      supplier: item.pending_transaction_supplier?.name,
      supplierId: item.pending_transaction_supplier?._id,
      type: item.pending_transaction?.transaction_type,
      document: item.pending_transaction?.document,
      note: item.pending_transaction?.notes,
      amount: item.pending_transaction?.amount,
      attachments: item.pending_transaction?.attachments || item.attachments || [],
    };
  }

  return {
    date: item.transaction_date,
    customer: `${item.customer?.firstName || ''} ${item.customer?.lastName || ''}`.trim(),
    customerId: item.customer?._id,
    supplier: item.supplier?.name,
    supplierId: item.supplier?._id,
    type: item.transaction_type,
    document: item.document,
    note: item.notes,
    amount: item.amount,
    attachments: item.attachments || [],
  };
};
